export default "__VITE_ASSET__Bv5gakPd__"